import {Store} from 'client/framework';
import {Map, fromJS} from 'immutable';
import lineChartActions from './LineChart.actions';

export default class LineChartStore extends Store {
  constructor(name) {
    super(name);

    this.initialData = fromJS({
      tooltipData: {},
      tooltipPosition: {},
      isTooltipVisible: false
    });

    this.setInitialData(this.initialData);
    this.handleTargeted(lineChartActions.CLEAR_TOOLTIP_DATA, this._clearTooltipData);
    this.handleTargeted(lineChartActions.SET_TOOLTIP_DATA, this._setTooltipData);
    this.handleTargeted(lineChartActions.TOGGLE_TOOLTIP, this._toggleTooltip);
  }

  _clearTooltipData() {
    this.writeData('tooltipData', new Map());
  }

  _setTooltipData(data) {
    this.writeData('tooltipData', data.get('data'));
    this.writeData('tooltipPosition', data.get('position'));
  }

  _toggleTooltip(isTooltipVisible) {
    this.writeData('isTooltipVisible', isTooltipVisible);
  }

  getTooltipData() {
    return this.readData('tooltipData');
  }

  getTooltipPosition() {
    return this.readData('tooltipPosition');
  }

  isTooltipVisible() {
    return this.readData('isTooltipVisible');
  }
}
